export default __webpack_public_path__ + "static/media/Susie_9781408345085.1eeda96d.jpg";